"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { getGroupFocusWithinAccessibleStyles as t } from "../../../utils/styles.mjs";
import { Text as n } from "../Text/Text.mjs";
import { forwardRef as r, useCallback as i, useImperativeHandle as a, useRef as o, useState as s } from "react";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
import { cva as u } from "class-variance-authority";
//#region src/components/atoms/FileInput/FileInput.tsx
var d = u("\n    flex\n    flex-col\n    size-full\n    rounded-sm\n    border\n    border-dashed\n    p-3\n    min-h-[7.5rem]\n    min-w-[15rem]\n    justify-center\n    transition-colors\n    \n    dark:bg-neutral-dark-200\n    dark:text-neutral-dark-600\n    ", {
	variants: {
		state: {
			default: "dark:border-neutral-dark-300",
			loading: "dark:border-neutral-dark-500",
			error: "border-red-400 dark:border-red-400",
			success: "dark:border-neutral-dark-300 min-h-0"
		},
		isDragActive: {
			true: "border-gray-300 dark:border-neutral-dark-600",
			false: ""
		},
		disabled: {
			true: "cursor-not-allowed",
			false: ""
		}
	},
	defaultVariants: {
		isDragActive: !1,
		disabled: !1
	}
}), f = u("\n    text-left\n    ", {
	variants: { state: {
		default: "",
		loading: "",
		success: "",
		error: "text-red-100"
	} },
	defaultVariants: { state: "default" }
}), p = r(({ className: r, wrapperClassName: u, state: p = "default", children: m, useButtonWrapper: h = !0, helperText: g, onPickFile: _, onFileDrop: v, onDragEnter: y, onDragOver: b, onDragLeave: x, onDrop: S, disabled: C, ...w }, T) => {
	let E = o(null);
	a(T, () => E.current);
	let [D, O] = s(!1), k = i((e) => {
		e.preventDefault(), e.stopPropagation(), !C && (O(!0), y?.(e));
	}, [C, y]), A = i((e) => {
		e.preventDefault(), e.stopPropagation(), b?.(e);
	}, [b]), j = i((e) => {
		e.preventDefault(), e.stopPropagation(), !e.currentTarget.contains(e.relatedTarget) && (O(!1), x?.(e));
	}, [x]), M = i((e) => {
		e.preventDefault(), e.stopPropagation(), O(!1), !C && (e.dataTransfer.files.length > 0 && v?.(e.dataTransfer.files), S?.(e));
	}, [
		C,
		v,
		S
	]), N = e(d({
		isDragActive: D,
		state: p,
		disabled: !!C
	}), t(), r), P = /* @__PURE__ */ c("div", {
		"data-testid": "interactive-zone",
		"data-drag-active": D || void 0,
		onDragEnter: k,
		onDragOver: A,
		onDragLeave: j,
		onDrop: M,
		className: N,
		children: m
	});
	return /* @__PURE__ */ l("div", {
		className: e("flex flex-col gap-2 group", u),
		children: [
			h ? /* @__PURE__ */ c("button", {
				type: "button",
				onClick: _,
				disabled: C,
				children: P
			}) : P,
			/* @__PURE__ */ c("input", {
				ref: E,
				type: "file",
				className: "sr-only",
				disabled: C,
				...w
			}),
			g && /* @__PURE__ */ c(n, {
				fontWeight: "regular",
				fontSize: "xs",
				className: f({ state: p }),
				children: g
			})
		]
	});
});
p.displayName = "FileInput";
//#endregion
export { p as FileInput };
